import { ICompanyLists } from '../model/companyLists.js';
import { EmailFrequency } from '../model/emailFrequency.js';
import { IEntityBase } from './entity-base.interface.js';

export interface IUserCompany {
	companyId: string;
}

export interface IUserAsset {
	assetId: string;
}

export interface IUserSector {
	sectorId: string;
	parentSectorId?: string;
	parentSearchId?: string;
}

export interface IUserLocation {
	locationId: string;
	parentSearchId?: string;
}

export interface IUserSearch extends IEntityBase {
	sectors: IUserSector[];
	locations: IUserLocation[];
	statuses: string;
	name: string;
}

export interface ICompany extends IEntityBase {
	lastReminderSent?: Date;
}

export interface IUserNewsUpdatePreferences {
	emailUpdates: boolean;
	emailNews: boolean;
	emailNewCompanies: boolean;
}

export interface IUser {
	id: number;
	userName: string;
	nickname: string;
	locationsFollowed: IUserLocation[];
	followCompaniesImResponsibleFor?: boolean;
	timeZoneOffsetInHours?: number;
	lastNewsletterEmailSentTimestamp: Date;
	emailNewsletterFrequency: EmailFrequency;
	lastViewedMyUpdatesTimestamp: Date;
	viewedStayInTheLoop: boolean;
	followBlueKnightCompanies: boolean;
	companyLists?: ICompanyLists;
	createdDate: Date;
	updatedDate: Date;

	assetsFollowed: IUserAsset[];
	companiesFollowed: IUserCompany[];
	sectorsFollowed: IUserSector[];
	userSearches: IUserSearch[];
	userNewsUpdatePreferences: IUserNewsUpdatePreferences;
}

export interface IUserWithLists extends IUser {
	companyLists: ICompanyLists;
}

export function hasUserPreferences(user: IUser): boolean {
	return (
		user?.companiesFollowed?.length > 0 ||
		user?.locationsFollowed?.length > 0 ||
		user?.sectorsFollowed?.length > 0 ||
		user?.userSearches?.length > 0 ||
		user?.followBlueKnightCompanies ||
		user?.followCompaniesImResponsibleFor
	);
}
